export function WarningIcon({
  className = "w-6 h-6",
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2411_9469)">
        <path d="M7.9987 10.6667V8.00001M7.9987 5.33334H8.00536M14.6654 8.00001C14.6654 11.6819 11.6806 14.6667 7.9987 14.6667C4.3168 14.6667 1.33203 11.6819 1.33203 8.00001C1.33203 4.31811 4.3168 1.33334 7.9987 1.33334C11.6806 1.33334 14.6654 4.31811 14.6654 8.00001Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_2411_9469">
          <rect width="16" height="16" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>

  );
}

export const displayName = "WarningIcon";
